export const noDataStyles = (theme) => ({
  root: {
    borderRadius: 0,
    fontWeight: '500',
    background: '#eee',
    textAlign: 'center',
    padding: theme.spacing(2),
  },
});
